module.exports = __webpack_public_path__ + "static/media/chevron-right-everdays-blue.a3648f4e.svg";